import React from 'react';

import {
  ContentHeading,
  ContentLink,
  ContentSubheading,
} from '../contentComponents';

import styles from './standardFlex.module.css';

const StandardFlex = ({
  heading,
  subheading,
  link,
  stat,
  quote,
  images,
  imagesContainerClassNames = '',
  imagesContainerStyles,
  customContent,
  isReverse,
}) => (
  <div
    className={`${styles.container} fade-in fade-2`}
    style={{ '--initialFlexDirection': isReverse ? 'row-reverse' : 'row' }}
  >
    <div className={styles.wordsContainer}>
      <ContentHeading text={heading} />
      <ContentSubheading text={subheading} />
      {link && (
        <ContentLink
          text={link.text}
          href={link.href}
          asPath={link.asPath}
          contactLink={link.contactLink}
        />
      )}
      {stat && (
        <div className={styles.stat}>
          <h2>{stat.heading}</h2>
          <p className="font-inter">{stat.description}</p>
        </div>
      )}

      {quote && (
        <div className={styles.quote}>
          <p className="font-inter">{quote.body}</p>
          <div className="mt-6">
            <div>
              <p className="font-inter font-semibold">{quote.author}</p>
              <p className="font-inter text-gray-300">{quote.role}</p>
            </div>

            <img
              className={`mt-3 h-${quote.logoHeight}`}
              src={quote.logo}
              alt={quote.role}
              loading="lazy"
            />
          </div>
        </div>
      )}
    </div>
    <div className="h-8 lg:w-16" />
    <div className="w-full lg:max-w-3xl">
      {images && (
        <figure
          className={`${imagesContainerClassNames} ${styles.figureContainer}`}
          style={imagesContainerStyles}
        >
          {images.map((img) => (
            <img
              key={img.src}
              width={img.width}
              height={img.height}
              src={img.src}
              alt={img.alt}
              style={img.style}
              className={img.className}
              loading="lazy"
            />
          ))}
        </figure>
      )}

      {customContent && customContent}
    </div>
  </div>
);
export default StandardFlex;
